import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodCoffee: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 2.5A2.5 2.5 0 0 1 4.5 0H5v5h-.5A2.5 2.5 0 0 1 2 2.5\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 6v4a6 6 0 0 0 11.197 3H12.5a3.5 3.5 0 1 0 0-7zm12 2v2q0 .511-.083 1h.583a1.5 1.5 0 1 0 0-3z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" d=\"M8.5 0a2.5 2.5 0 0 0 0 5H9V0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodCoffee
